import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_ColumnDef,
    MRT_ColumnFiltersState,
    MRT_EditActionButtons,
    MRT_Row,
    useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip,} from '@mui/material';
import {QueryClient} from '@tanstack/react-query';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {NCDTO} from './types';
import {useDeleteNC, useGetNCDTO} from './Services';
import {useTabSettings} from '../../common/Services';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddNC from "./AddNC";
import EditNC from "./EditNC";
import ExpNC from "./ExpNC";
import {useDeleteDatiProg} from "../gestdatiprog/Services";


interface ListaNCProps {}

const ListaNC: React.FC<ListaNCProps> = () => {
    const [validationErrors, setValidationErrors] = useState<Record<string, string | undefined>>({});
    const [globalFilter, setGlobalFilter] = useState('');
    const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(0);
    const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);
    const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

    const keyusername = localStorage.getItem('keyusername') || 'NN';

    const {
        columnVisibility,
        setColumnVisibility,
        columnFilters,
        setColumnFilters,
        sorting,
        setSorting,
        pagination,
        setPagination,
        saveTabSettings,
    } = useTabSettings('ListaNC', keyusername);
    const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);
    const {mutateAsync: deleteVersore2, isPending: isDeletingVersore2} = useDeleteNC();


    const {
        data: {results = [], count } = {},
        isError: isLoadingNCDTOError,
        isFetching: isFetchingNCDTO,
        isLoading: isLoadingNCDTO,
        error
    } = useGetNCDTO(pagination, columnFilters, globalFilter, sorting);

  const { mutateAsync: deleteNC, isPending: isDeletingNC } = useDeleteNC();

    const columns = useMemo<MRT_ColumnDef<NCDTO>[]>(() => [
        {accessorKey: "idnc", header: "ID", size: 2, enableEditing: false},
         {accessorKey: 'dataapertura',
            header: 'DataApert.',
            size: 2,
            filterVariant: 'date-range',
            Cell: ({cell}) => {
                const value = cell.getValue<string>();
                if (!value) return '';

                return new Date(value).toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit',
                });
            },
        },

        {
            accessorKey: 'datachiusura',
            header: 'DataChius.',
            size: 2,
            filterVariant: 'date-range',
            Cell: ({cell}) => {
                const value = cell.getValue<string>();
                if (!value) return '';

                return new Date(value).toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit',
                });
            },
        },
             {accessorKey: "titolo", header: "Titolo", size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },
        // {accessorKey: "ditta", header: "Ditta", size: 50},
        {accessorKey: "note", header: "Note", size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },
        {accessorKey: 'desprog', header: 'Progetto', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },
        {accessorKey: "descatnc", header: "Categoria", size: 100},
        {accessorKey: "desstatonc", header: "Stato", size: 100},
        {accessorKey: "deslivellonc", header: "Livello", size: 100},
        {accessorKey: "coddip", header: "Dip.", size: 2},
        {accessorKey: "auditor", header: "Auditor", size: 100},

    ], [validationErrors]);




const openDeleteConfirmModal = (row: MRT_Row<NCDTO>) => {
  if (window.confirm(`ATTENZIONE !!! CANCELLAZIONE DEL ... "${row.original.idnc}"`)) {
      deleteNC(row.original.idnc);
  }
};


  const openAddModal = () => setIsDialogAddOpen(true);

  const openEditModal = (row: MRT_Row<NCDTO>) => {
    setIsDialogEditOpen(true);
    setCurrentRowId(row.original.idnc ?? 0);
  };




  const table = useMaterialReactTable({
    columns,
 data: results,
    initialState: { density: 'compact'},
    createDisplayMode: 'modal',
    editDisplayMode: 'modal',
    enableEditing: true,
    enableColumnActions: false,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    getRowId: (row) => row.idnc?.toString() ?? '',
    muiToolbarAlertBannerProps: isLoadingNCDTOError
      ? {
          color: 'error',
          children: 'Errore nel caricamento dei dati',
        }
      : undefined,
    muiTableContainerProps: { sx: { minHeight: '500px' } },
    // muiTableBodyCellProps: {  sx: { paddingX: '1px', }, },
    // muiTableHeadCellProps: {  sx: { paddingX: '1px', }, },

    // muiSearchTextFieldProps: {
    //     placeholder: 'NNREL,Ref,Prog,Note',
    //     sx: { minWidth: "600px", fontSize: '0.75rem', },
    //     variant: 'outlined',
    //   },

     // per compattazione tabella padding first above and below second left and right
     muiTableBodyCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '.9rem',
          },
        },

     muiTableHeadCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '0.9rem',
          },
        },

// fine compattazione vedi anche row actions
//     muiTableBodyRowProps: ({ row }) => ({
//         sx: { backgroundColor: row.original.variante ? '#fff3cd' : 'inherit',  },
//     }),


    renderTopToolbarCustomActions: () => (
      <>
            <Stack
              direction="row"
              spacing={0}
              sx={{
                width: '60%',
                padding: '4px',
                alignItems: 'center',
              }}
            >
              <Box sx={{ width: '25%', textAlign: 'right' }}>
                 <Button
                    variant="contained"
                    onClick={openAddModal}
                    sx={{ width: 160 }}
                  >
                   Nuovo
                  </Button>

              </Box>


                <Box sx={{ width: '25%', textAlign: 'right' }}>

</Box>



   <Box sx={{ width: '25%', textAlign: 'right' }}>
                <Button
                  variant="contained"
                  onClick={() => setIsDialogExporterOpen(true)}
                  startIcon={<FileDownloadIcon />}
                  sx={{ width: 160 }}
                >
                  EXPORT DATI
                </Button>
                  {isDialogExporterOpen && (
                        <ExpNC
                          pagination={pagination}
                          columnFilters={columnFilters}
                          globalFilter={globalFilter}
                          sorting={sorting}
                          columnVisibility={columnVisibility}
                          columns={columns}
                          onClose={() => setIsDialogExporterOpen(false)}
                        />)}

                </Box>


              <Box sx={{ width: '25%', textAlign: 'right' }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setColumnFilters(draftColumnFilters);
                    saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                  }}
                  sx={{ width: 160 }}
                >
                  Applica Filtri
                </Button>
              </Box>
            </Stack>

                  </>
                ),


    //
    // renderRowActions: ({ row }) => (
    //   <Box sx={{ display: 'flex', gap: '0.2rem' }}>
    //     <Tooltip title="Modifica">
    //       <IconButton onClick={() => openEditModal(row)}>
    //         <EditIcon />
    //       </IconButton>
    //     </Tooltip>
    //     <Tooltip title="Rimuovi">
    //       <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
    //         <DeleteIcon />
    //       </IconButton>
    //     </Tooltip>
    //   </Box>
    // ),
    //
 renderRowActions: ({ row }) => (
  <Box sx={{ display: 'flex', gap: '2px' }}>
    <Tooltip title="Modifica">
      <IconButton size="small" onClick={() => openEditModal(row)}>
        <EditIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>

    <Tooltip title="Rimuovi">
      <IconButton size="small" color="error" onClick={() => openDeleteConfirmModal(row)}>
        <DeleteIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  </Box>
),

    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Crea Nuovo</DialogTitle>
        <DialogContent sx={{ width: '1000px' }}>{internalEditComponents}</DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Modifica</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {internalEditComponents}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    state: {
      columnFilters,
      // columnFilters: immediateColumnFilters,  //per gestire il ritardo dell input  MP
      globalFilter,
      pagination,
      sorting,
      columnVisibility,
      isLoading: isLoadingNCDTO,
      // isSaving: isDeletingVersore2,
      showAlertBanner: isLoadingNCDTOError,
      showProgressBars: isFetchingNCDTO,
    },
    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),

    // onColumnFiltersChange: setImmediateColumnFilters,
    onColumnFiltersChange: setDraftColumnFilters,

    // onColumnFiltersChange: (updater) => {
    //   const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    //   setColumnFilters(newFilters);
    //   saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    // },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },

    rowCount: count ?? 0,
  });

  return (
    <Box sx={{ mt: '60px' }}>
      <MaterialReactTable table={table} />
        {isDialogAddOpen && <AddNC open onClose={() => setIsDialogAddOpen(false)} />}
        {isDialogEditOpen &&  (<EditNC open idncprop={currentRowId} onClose={() => setIsDialogEditOpen(false)} /> )}

    </Box>
  );
};

const queryClient = new QueryClient();
export default ListaNC;
